import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_TO_DEMO_2 = {
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "topaz.png",
  title:
    "Rick explores a dynamic map UI \nshowcasing current turf zoning. \nHovering over zones reveals details, \nempowering him with comprehensive \ninsights for informed decisions.",
  subtitle: "turf optimization DEMO",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage(407),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(405),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "TURF_OPTIMIZATION/TO_bg_4.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "TURF_OPTIMIZATION/TO_DEMO_2_1.png",
          imageStyle: {
            position: "absolute",
            right: "0px",
            bottom: "0px",
          },
        },
        {
          image: "TURF_OPTIMIZATION/TO_DEMO_2_2.png",
          imageStyle: {
            position: "absolute",
            right: "0px",
            bottom: "0px",
          },
        },
      ]}
      pageNumber={406}
    />
  ),
};
